import { Link } from 'react-router-dom';
import { EmptyState } from '../../components/ui/EmptyState';
import { AGE_BUCKETS, getAgeBucketHref } from '../../constants/ageBuckets';
import { CHIP_BASE_CLASS, CHIP_INACTIVE_CLASS } from '../../constants/chipStyles';
import { useAuthStore } from '../../store/authStore';
import { FOCUS_RING, LINK_BUTTON_GHOST, LINK_BUTTON_PRIMARY } from './cartStyles';

interface CartEmptyProps {
  catalogHref: string;
}

export function CartEmpty({ catalogHref }: CartEmptyProps) {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);

  return (
    <div className="max-w-2xl mx-auto px-4 py-8">
      <EmptyState
        title="Sua sacola está vazia"
        description="Escolha algumas peças no catálogo ou comece pela idade de quem vai usar."
        action={
          <Link to={catalogHref} className={LINK_BUTTON_PRIMARY}>
            Ver produtos
          </Link>
        }
      />
      <nav aria-label="Ver peças por idade" className="flex flex-wrap justify-center gap-2 mt-2">
        {AGE_BUCKETS.map((bucket) => (
          <Link
            key={bucket.key}
            to={getAgeBucketHref(bucket)}
            className={`${CHIP_BASE_CLASS} ${CHIP_INACTIVE_CLASS} min-h-11 inline-flex items-center bg-white ${FOCUS_RING}`}
          >
            {bucket.label}
          </Link>
        ))}
      </nav>
      {isAuthenticated && (
        <div className="flex justify-center mt-4">
          <Link to="/favoritos" className={LINK_BUTTON_GHOST}>
            Ver meus favoritos
          </Link>
        </div>
      )}
    </div>
  );
}
